// ABOUTME: Loads the license offers for a collection and mounts the purchase dialog (DVLP-7860).
// ABOUTME: Mounted once for every /register/:uuid page, so the collection and course pages share it.
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { RegisterResource } from '../../../DiscoveryPortal/RegisterResourceStore/Types';
import licensePurchaseStore from '../Store';
import LicensePurchaseModal from './LicensePurchaseModal';

interface Props {
  invitationUuid: string;
  registerResource: RegisterResource;
}

function LicensePurchaseShelf({ invitationUuid, registerResource }: Props) {
  const invitation = registerResource.payload.sharedInvitation.payload;

  useEffect(() => {
    switch (invitation.kind) {
      case 'preview-only': {
        // An admin previewing a collection cannot buy anything.
        return;
      }
      case 'use-case':
      case 'use-cases-program-family': {
        licensePurchaseStore.load(invitationUuid, invitation.licenseCommerceType);
      }
    }
  }, [invitationUuid, invitation.kind, invitation.licenseCommerceType]);

  return <LicensePurchaseModal />;
}

export default observer(LicensePurchaseShelf);
